import { mobileRegex, emailRegex, panRegex } from '../../../../utils/constants';
import * as Yup from 'yup';
import enUs from '../../../../lang/en-us';

const { dashboard } = enUs;

const drivingLicenseRegex = /^[A-Z]{2}[A-Za-z0-9_]{8,48}$/;
const aadharRegex = new RegExp('^[0-9]{4}$');
const passportNumberRegex = /(^[A-PR-WY][0-9]{7}$)|(^[A-Z0-9]{5,15}$)/;

export const indiaPincodeRegex = /^\d{6}$/;
export const nonIndiaPincodeRegex = /^[A-Za-z0-9]{4,20}$/;

export enum IdType {
    Aadhaar = 'A',
    PAN = 'P',
    DrivingLicense = 'D',
    PassportNumber = 'I',
}

export const nomineeValidationSchema = Yup.object().shape({
    name: Yup.string()
        .required('Nominee name is required')
        .min(3, 'Invalid Nominee name. please enter valid name'),
    relation: Yup.string().test('relation', 'Relationship is required', (value) => {
        if (value === dashboard.UpdateNominee.selectRelation) {
            return false;
        }
        return true;
    }),
    gender: Yup.string().required('Gender is required'),
    dob: Yup.date().required('Date of Birth is required'),
    email: Yup.string()
        .required('Email is required')
        .matches(emailRegex, 'Enter valid email address'),
    mobile: Yup.string()
        .required('Mobile is required')
        .matches(mobileRegex, 'Enter valid mobile number'),
    share: Yup.number()
        .required('Nominee Percentage required')
        .positive('Nominee Percentage should be greater than 0')
        .max(100, 'Nominee Percentage should not be greater than 100'),
    docName: Yup.string().required('ID Type is mandatory'),
    docValue: Yup.string()
        .required('ID Number is mandatory')
        .when('docName', {
            is: 'ID Type',
            then: (schema) => schema.required('ID Type is mandatory'),
            otherwise: (schema) => schema.notRequired(),
        })
        .when('docName', {
            is: IdType.Aadhaar,
            then: (schema) =>
                schema
                    .matches(/^\d{4}$/, 'Please enter last four digits of Aadhaar Number')
                    .test(
                        'is-valid-aadhaar',
                        'Enter a valid Aadhaar number',
                        (value) => value !== '0000', // Reject 0000 as invalid
                    )
                    .required('Aadhaar Number is mandatory'),
        })
        .when('docName', {
            is: IdType.PAN,
            then: (schema) => schema.matches(panRegex, 'Enter valid PAN'),
        })
        .when('docName', {
            is: IdType.DrivingLicense,
            then: (schema) => schema.matches(drivingLicenseRegex, 'Enter valid driving license'),
        })
        .when('docName', {
            is: IdType.PassportNumber,
            then: (schema) => schema.matches(passportNumberRegex, 'Enter valid Passport Number'),
        }),
    // guardianName: Yup.string().when('isMinor', {
    //     is: 'Yes',
    //     then: Yup.string().notRequired().min(4, 'Invalid Guardian name. Please enter a valid name'),
    //     otherwise: Yup.string().notRequired(),
    // }),
    inCapacitationAmount: Yup.number().when('inCapacitation', {
        is: true,
        then: Yup.number().when('inCapacitationAmountorPercentageCheck', {
            is: 'Percentage',
            then: Yup.number()
                .min(1, 'Percentage must be at least 1%')
                .max(100, 'Percentage should not exceed 100%')
                .required('Percentage is required'),
            otherwise: Yup.number()
                .min(1, 'Amount must be at least 1₹')
                .required('Amount is required'),
        }),
    }),
    address1: Yup.string().when('addressSameAsFH', {
        is: 'Y',
        then: Yup.string().notRequired(),
        otherwise: Yup.string().required('Address is required'),
    }),
    city: Yup.string().when('addressSameAsFH', {
        is: 'Y',
        then: Yup.string().notRequired(),
        otherwise: Yup.string().required('City is required'),
    }),
    state: Yup.string().when('addressSameAsFH', {
        is: 'Y',
        then: Yup.string().notRequired(),
        otherwise: Yup.string().required('State is required'),
    }),
    country: Yup.string().when('addressSameAsFH', {
        is: 'Y',
        then: Yup.string().notRequired(),
        otherwise: Yup.string().required('Country is required'),
    }),
    pincode: Yup.string().when('addressSameAsFH', {
        is: 'Y',
        then: Yup.string().notRequired(),
        otherwise: Yup.string().when('country', {
            is: 'India',
            then: Yup.string()
                .required('Pincode is required')
                .min(6, 'Pincode should be at least 6 characters')
                .max(6, 'Pincode should not be greater than 6 characters')
                .matches(indiaPincodeRegex, 'Enter valid pincode'),
            otherwise: Yup.string()
                .required('Pincode is required')
                .min(4, 'Pincode should be at least 4 characters')
                .max(20, 'Pincode should not be greater than 20 characters')
                .matches(nonIndiaPincodeRegex, 'Enter valid pincode'),
        }),
    }),
});
